import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isLoggedIn } from '../../utils/auth';
import { saveGenericRedirectUrl } from '../../utils/authRedirect';

interface AuthWrapperProps {
  children: ReactNode;
}

const AuthWrapper = ({ children }: AuthWrapperProps) => {
  const location = useLocation();

  if (!isLoggedIn() && !location.search.includes('token')) {
    saveGenericRedirectUrl(location.pathname + location.search);

    return <Navigate replace to="/enter" state={{ from: location }} />;
  }

  return children;
};

export default AuthWrapper;
